<template>
  <NoDataTable v-if="!dataResult.length" />
  <div v-else>
    <div class="header-flex">
      <div class="header-title">
        <h3>All Company Utilization Report</h3>
        <h4>
          Year
          {{ dataDetails.year }}
        </h4>
        <h4>{{ dataDetails.category }} Accounts</h4>
      </div>
      <input type="button" value="Download Excel" @click="exportTableToExcel" />
    </div>
    <div class="main-table">
      <table id="excelDownload">
        <thead>
          <tr>
            <th rowspan="3">Company</th>
            <th colspan="4">January</th>
            <th colspan="4">February</th>
            <th colspan="4">March</th>
            <th colspan="4">April</th>
            <th colspan="4">May</th>
            <th colspan="4">June</th>
            <th colspan="4">July</th>
            <th colspan="4">August</th>
            <th colspan="4">September</th>
            <th colspan="4">October</th>
            <th colspan="4">November</th>
            <th colspan="4">December</th>
          </tr>
          <tr>
            <!-- January -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- February -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- March -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- April -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- May -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- June -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- July -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- August -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- September -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- October -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- November -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
            <!-- December -->
            <th rowspan="3">Active Mem.</th>
            <th rowspan="3">IWC Share</th>
            <th rowspan="3">Availment</th>
            <th rowspan="3">Percentage</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in modifiedDataHandler" :key="index">
            <td class="col-span-1">{{ item["COMPNAME"] }}</td>
            <!-- January -->
            <td class="col-span-2">{{ item["jan_actives"] }}</td>
            <td class="col-span-2">{{ item["jan"] }}</td>
            <td class="col-span-2">{{ item["jan_avail"] }}</td>
            <td class="col-span-2">{{ item["jan_percnt"] }}</td>
            <!-- February -->
            <td class="col-span-2">{{ item["feb_actives"] }}</td>
            <td class="col-span-2">{{ item["feb"] }}</td>
            <td class="col-span-2">{{ item["feb_avail"] }}</td>
            <td class="col-span-2">{{ item["feb_percnt"] }}</td>
            <!-- March -->
            <td class="col-span-2">{{ item["mar_actives"] }}</td>
            <td class="col-span-2">{{ item["mar"] }}</td>
            <td class="col-span-2">{{ item["mar_avail"] }}</td>
            <td class="col-span-2">{{ item["mar_percnt"] }}</td>
            <!-- April -->
            <td class="col-span-2">{{ item["apr_actives"] }}</td>
            <td class="col-span-2">{{ item["apr"] }}</td>
            <td class="col-span-2">{{ item["apr_avail"] }}</td>
            <td class="col-span-2">{{ item["apr_percnt"] }}</td>
            <!-- May -->
            <td class="col-span-2">{{ item["may_actives"] }}</td>
            <td class="col-span-2">{{ item["may"] }}</td>
            <td class="col-span-2">{{ item["may_avail"] }}</td>
            <td class="col-span-2">{{ item["may_percnt"] }}</td>
            <!-- June -->
            <td class="col-span-2">{{ item["jun_actives"] }}</td>
            <td class="col-span-2">{{ item["jun"] }}</td>
            <td class="col-span-2">{{ item["jun_avail"] }}</td>
            <td class="col-span-2">{{ item["jun_percnt"] }}</td>
            <!-- July -->
            <td class="col-span-2">{{ item["jul_actives"] }}</td>
            <td class="col-span-2">{{ item["jul"] }}</td>
            <td class="col-span-2">{{ item["jul_avail"] }}</td>
            <td class="col-span-2">{{ item["jul_percnt"] }}</td>
            <!-- August -->
            <td class="col-span-2">{{ item["aug_actives"] }}</td>
            <td class="col-span-2">{{ item["aug"] }}</td>
            <td class="col-span-2">{{ item["aug_avail"] }}</td>
            <td class="col-span-2">{{ item["aug_percnt"] }}</td>
            <!-- September -->
            <td class="col-span-2">{{ item["sep_actives"] }}</td>
            <td class="col-span-2">{{ item["sep"] }}</td>
            <td class="col-span-2">{{ item["sep_avail"] }}</td>
            <td class="col-span-2">{{ item["sep_percnt"] }}</td>
            <!-- October -->
            <td class="col-span-2">{{ item["oct_actives"] }}</td>
            <td class="col-span-2">{{ item["oct"] }}</td>
            <td class="col-span-2">{{ item["oct_avail"] }}</td>
            <td class="col-span-2">{{ item["oct_percnt"] }}</td>
            <!-- November -->
            <td class="col-span-2">{{ item["nov_actives"] }}</td>
            <td class="col-span-2">{{ item["nov"] }}</td>
            <td class="col-span-2">{{ item["nov_avail"] }}</td>
            <td class="col-span-2">{{ item["nov_percnt"] }}</td>
            <!-- December -->
            <td class="col-span-2">{{ item["decm_actives"] }}</td>
            <td class="col-span-2">{{ item["decm"] }}</td>
            <td class="col-span-2">{{ item["dec_avail"] }}</td>
            <td class="col-span-2">{{ item["dec_percnt"] }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="footer">
            <td colspan="1">TOTAL:</td>
            <!-- January -->
            <td>{{ JAN_activemem(modifiedDataHandler) }}</td>
            <td>{{ JAN_remittance(modifiedDataHandler) }}</td>
            <td>{{ JAN_availment(modifiedDataHandler) }}</td>
            <td>{{ JAN_percent(modifiedDataHandler) }}</td>
            <!-- February -->
            <td>{{ FEB_activemem(modifiedDataHandler) }}</td>
            <td>{{ FEB_remittance(modifiedDataHandler) }}</td>
            <td>{{ FEB_availment(modifiedDataHandler) }}</td>
            <td>{{ FEB_percent(modifiedDataHandler) }}</td>
            <!-- March -->
            <td>{{ MAR_activemem(modifiedDataHandler) }}</td>
            <td>{{ MAR_remittance(modifiedDataHandler) }}</td>
            <td>{{ MAR_availment(modifiedDataHandler) }}</td>
            <td>{{ MAR_percent(modifiedDataHandler) }}</td>
            <!-- April -->
            <td>{{ APR_activemem(modifiedDataHandler) }}</td>
            <td>{{ APR_remittance(modifiedDataHandler) }}</td>
            <td>{{ APR_availment(modifiedDataHandler) }}</td>
            <td>{{ APR_percent(modifiedDataHandler) }}</td>
            <!-- May -->
            <td>{{ MAY_activemem(modifiedDataHandler) }}</td>
            <td>{{ MAY_remittance(modifiedDataHandler) }}</td>
            <td>{{ MAY_availment(modifiedDataHandler) }}</td>
            <td>{{ MAY_percent(modifiedDataHandler) }}</td>
            <!-- June -->
            <td>{{ JUN_activemem(modifiedDataHandler) }}</td>
            <td>{{ JUN_remittance(modifiedDataHandler) }}</td>
            <td>{{ JUN_availment(modifiedDataHandler) }}</td>
            <td>{{ JUN_percent(modifiedDataHandler) }}</td>
            <!-- July -->
            <td>{{ JUL_activemem(modifiedDataHandler) }}</td>
            <td>{{ JUL_remittance(modifiedDataHandler) }}</td>
            <td>{{ JUL_availment(modifiedDataHandler) }}</td>
            <td>{{ JUL_percent(modifiedDataHandler) }}</td>
            <!-- August -->
            <td>{{ AUG_activemem(modifiedDataHandler) }}</td>
            <td>{{ AUG_remittance(modifiedDataHandler) }}</td>
            <td>{{ AUG_availment(modifiedDataHandler) }}</td>
            <td>{{ AUG_percent(modifiedDataHandler) }}</td>
            <!-- September -->
            <td>{{ SEP_activemem(modifiedDataHandler) }}</td>
            <td>{{ SEP_remittance(modifiedDataHandler) }}</td>
            <td>{{ SEP_availment(modifiedDataHandler) }}</td>
            <td>{{ SEP_percent(modifiedDataHandler) }}</td>
            <!-- October -->
            <td>{{ OCT_activemem(modifiedDataHandler) }}</td>
            <td>{{ OCT_remittance(modifiedDataHandler) }}</td>
            <td>{{ OCT_availment(modifiedDataHandler) }}</td>
            <td>{{ OCT_percent(modifiedDataHandler) }}</td>
            <!-- November -->
            <td>{{ NOV_activemem(modifiedDataHandler) }}</td>
            <td>{{ NOV_remittance(modifiedDataHandler) }}</td>
            <td>{{ NOV_availment(modifiedDataHandler) }}</td>
            <td>{{ NOV_percent(modifiedDataHandler) }}</td>
            <!-- December -->
            <td>{{ DEC_activemem(modifiedDataHandler) }}</td>
            <td>{{ DEC_remittance(modifiedDataHandler) }}</td>
            <td>{{ DEC_availment(modifiedDataHandler) }}</td>
            <td>{{ DEC_percent(modifiedDataHandler) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import UsedFormatUtils from "@/utils/format";
import UsedPaginationUtils from "@/utils/pagination";
import { computed, watch, inject } from "vue";
import ExcelJS from "exceljs";
export default {
  props: {
    dataResult: Object,
    dataDetails: Object,
    searchData: String,
  },
  setup(props) {
    const { convertDateReportFormat, convertDateFormat, convertAmountFormat } =
      UsedFormatUtils();
    const moment = inject("$moment");
    const { paginationItem, filterLimit } = UsedPaginationUtils();

    const modifiedDataHandler = computed(() => {
      let dataItems = props.dataResult;
      let search = (props.searchData || "").toLowerCase().trim();

      let resultData = dataItems.filter((val) => {
        return val.COMPNAME?.toLowerCase().includes(search);
      });
      return resultData;
    });

    const JAN_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jan_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JAN_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jan"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JAN_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jan_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JAN_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["jan_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["jan"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const FEB_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["feb_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const FEB_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["feb"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const FEB_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["feb_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const FEB_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["feb_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["feb"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const MAR_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["mar_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAR_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["mar"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAR_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["mar_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAR_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["mar_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["mar"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const APR_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["apr_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const APR_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["apr"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const APR_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["apr_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const APR_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["apr_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["apr"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const MAY_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["may_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAY_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["may"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAY_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["may_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const MAY_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["may_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["may"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const JUN_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jun_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUN_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jun"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUN_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jun_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUN_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["jun_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["jun"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const JUL_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jul_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUL_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jul"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUL_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["jul_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const JUL_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["jul_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["jul"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const AUG_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["aug_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const AUG_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["aug"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const AUG_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["aug_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const AUG_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["aug_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["aug"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const SEP_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["sep_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const SEP_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["sep"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const SEP_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["sep_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const SEP_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["sep_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["sep"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const OCT_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["oct_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const OCT_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["oct"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const OCT_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["oct_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const OCT_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["oct_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["oct"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const NOV_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["nov_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const NOV_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["nov"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const NOV_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["nov_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const NOV_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["nov_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["nov"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };
    const DEC_activemem = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["decm_actives"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const DEC_remittance = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["decm"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const DEC_availment = (val) => {
      let resultData = val;
      let total = resultData
        .map((val) => parseFloat(val["dec_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0)
        .toLocaleString("en-US");
      return total;
    };
    const DEC_percent = (val) => {
      let resultData = val;
      let totalAvailmentAmount = resultData
        .map((val) => parseFloat(val["dec_avail"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let totalAmountRemittance = resultData
        .map((val) => parseFloat(val["decm"].replace(/,/g, "")) || 0)
        .reduce((sum, total) => sum + total, 0);

      let result = `${(
        (totalAvailmentAmount / totalAmountRemittance) *
        100
      ).toFixed(2)}%`;

      return result;
    };

    watch(() => props.searchData);
    const handlePageChange = (page) => {
      paginationItem.currentPage = page;
      watch(() => paginationItem.currentPage);
    };

    const exportTableToExcel = async () => {
      const table = document.getElementById("excelDownload");
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add Title (A1)
      worksheet.getCell(
        "A1"
      ).value = `All Utilization Report for the Year ${props.dataDetails.year}`;
      worksheet.getCell("A1").font = { bold: true, size: 13 };
      worksheet.getCell("A1").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Add Subtitle (A2)
      worksheet.getCell("A2").value = `Extracted Date: ${moment().format(
        "MMMM D, YYYY | h:mmA"
      )}`;
      worksheet.getCell("A2").font = { bold: false, size: 12 };
      worksheet.getCell("A2").alignment = {
        horizontal: "left",
        vertical: "middle",
      };
      // Leave Rows 3-5 empty for spacing before table
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      // Headers start at row 6
      const headers = [
        [
          "Company",
          "January",
          "",
          "",
          "", // January has 4 sub-columns
          "February",
          "",
          "",
          "", // February has 4 sub-columns
          "March",
          "",
          "",
          "", // Repeat for all months...
          "April",
          "",
          "",
          "",
          "May",
          "",
          "",
          "",
          "June",
          "",
          "",
          "",
          "July",
          "",
          "",
          "",
          "August",
          "",
          "",
          "",
          "September",
          "",
          "",
          "",
          "October",
          "",
          "",
          "",
          "November",
          "",
          "",
          "",
          "December",
          "",
          "",
          "",
        ],
        [
          "",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage", // January sub-columns
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage", // February sub-columns
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage", // March sub-columns
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage", // and so on...
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
          "Active Member",
          "IWC Share",
          "Availment",
          "Percentage",
        ],
      ];

      // Add headers starting at row 6
      headers.forEach((row) => worksheet.addRow(row));

      // Merge Header Cells Properly (Starting at Row 6)
      worksheet.mergeCells("A6:A8");
      worksheet.mergeCells("B6:E6");
      worksheet.mergeCells("B7:B8");
      worksheet.mergeCells("C7:C8");
      worksheet.mergeCells("D7:D8");
      worksheet.mergeCells("E7:E8");

      worksheet.mergeCells("F6:I6");
      worksheet.mergeCells("F7:F8");
      worksheet.mergeCells("G7:G8");
      worksheet.mergeCells("H7:H8");
      worksheet.mergeCells("I7:I8");

      worksheet.mergeCells("J6:M6");
      worksheet.mergeCells("J7:J8");
      worksheet.mergeCells("K7:K8");
      worksheet.mergeCells("L7:L8");
      worksheet.mergeCells("M7:M8");

      worksheet.mergeCells("N6:Q6");
      worksheet.mergeCells("N7:N8");
      worksheet.mergeCells("O7:O8");
      worksheet.mergeCells("P7:P8");
      worksheet.mergeCells("Q7:Q8");

      worksheet.mergeCells("R6:U6");
      worksheet.mergeCells("R7:R8");
      worksheet.mergeCells("S7:S8");
      worksheet.mergeCells("T7:T8");
      worksheet.mergeCells("U7:U8");

      worksheet.mergeCells("V6:Y6");
      worksheet.mergeCells("V7:V8");
      worksheet.mergeCells("W7:W8");
      worksheet.mergeCells("X7:X8");
      worksheet.mergeCells("Y7:Y8");

      worksheet.mergeCells("Z6:AC6");
      worksheet.mergeCells("Z7:Z8");
      worksheet.mergeCells("AA7:AA8");
      worksheet.mergeCells("AB7:AB8");
      worksheet.mergeCells("AC7:AC8");

      worksheet.mergeCells("AD6:AG6");
      worksheet.mergeCells("AD7:AD8");
      worksheet.mergeCells("AE7:AE8");
      worksheet.mergeCells("AF7:AF8");
      worksheet.mergeCells("AG7:AG8");

      worksheet.mergeCells("AH6:AK6");
      worksheet.mergeCells("AH7:AH8");
      worksheet.mergeCells("AI7:AI8");
      worksheet.mergeCells("AJ7:AJ8");
      worksheet.mergeCells("AK7:AK8");

      worksheet.mergeCells("AL6:AO6");
      worksheet.mergeCells("AL7:AL8");
      worksheet.mergeCells("AM7:AM8");
      worksheet.mergeCells("AN7:AN8");
      worksheet.mergeCells("AO7:AO8");

      worksheet.mergeCells("AP6:AS6");
      worksheet.mergeCells("AP7:AP8");
      worksheet.mergeCells("AQ7:AQ8");
      worksheet.mergeCells("AR7:AR8");
      worksheet.mergeCells("AS7:AS8");

      worksheet.mergeCells("AT6:AW6");
      worksheet.mergeCells("AT7:AT8");
      worksheet.mergeCells("AU7:AU8");
      worksheet.mergeCells("AV7:AV8");
      worksheet.mergeCells("AW7:AW8");

      // Apply Styling to Header Rows
      for (let i = 6; i <= 8; i++) {
        worksheet.getRow(i).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }

      // Extract and Add Table Body Data (Starting at Row 9)
      for (let row of table.querySelectorAll("tbody tr")) {
        let rowData = [];
        row.querySelectorAll("td").forEach((cell, index) => {
          let value = cell.innerText.trim();

          if (
            [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45].includes(index) &&
            !isNaN(value)
          ) {
            value = Number(value);
          }
          if (
            [
              2, 3, 6, 7, 10, 11, 14, 15, 18, 19, 22, 23, 26, 27, 30, 31, 34,
              35, 38, 39, 42, 43, 46, 47,
            ].includes(index)
          ) {
            value = parseFloat(value.replace(/[₱,]/g, ""));
          }
          if ([4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48].includes(index)) {
            value = parseFloat(value) / 100;
          }

          rowData.push(value);
        });

        const addedRow = worksheet.addRow(rowData);

        // Apply borders to data rows
        addedRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }

      // Handle the Footer Row (TOTAL Row)
      const footerRow = table.querySelector("tfoot tr");
      if (footerRow) {
        let footerData = [];
        footerRow.querySelectorAll("td").forEach((cell) => {
          footerData.push(cell.innerText.trim());
        });

        let totalRow = worksheet.addRow(footerData);
        let totalRowIndex = totalRow.number;

        // Set "TOTAL" text in column A
        worksheet.getCell(`A${totalRowIndex}`).value = "TOTAL";
        worksheet.getCell(`A${totalRowIndex}`).font = { bold: true };
        worksheet.getCell(`A${totalRowIndex}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        totalRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          // Apply yellow background color
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "95FFC4" },
          };
        });

        // Assign footer values to the correct columns
        const totalColumns = [
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "AA",
          "AB",
          "AC",
          "AD",
          "AE",
          "AF",
          "AG",
          "AH",
          "AI",
          "AJ",
          "AK",
          "AL",
          "AM",
          "AN",
          "AO",
          "AP",
          "AQ",
          "AR",
          "AS",
          "AT",
          "AU",
          "AV",
          "AW",
        ];

        totalColumns.forEach((col, index) => {
          worksheet.getCell(`${col}${totalRowIndex}`).value =
            footerData[index + 1] || "";
          worksheet.getCell(`${col}${totalRowIndex}`).font = { bold: true };

          let cell = worksheet.getCell(`${col}${totalRowIndex}`);
          let value = footerData[index + 1] || "";

          totalColumns.forEach((col) => {
            let cell = worksheet.getCell(`${col}${totalRowIndex}`);

            // Apply yellow background color
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "95FFC4" }, // Yellow
            };

            // Apply border
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            // Apply number formatting only to specific columns

            if ([1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45].includes(index)) {
              let value = cell.value;
              let numericValue =
                !isNaN(value) && value !== "" ? parseFloat(value) : value;
              cell.value = numericValue;

              if (typeof numericValue === "number") {
                cell.numFmt = "#,##0";
              }
            }
            if (
              [
                2, 3, 6, 7, 10, 11, 14, 15, 18, 19, 22, 23, 26, 27, 30, 31, 34,
                35, 38, 39, 42, 43, 46, 47,
              ].includes(index)
            ) {
              let value = cell.value;

              // Ensure the value is a string before using replace
              if (typeof value === "string") {
                cell.value = parseFloat(value.replace(/[₱,]/g, "")); // Clean and set the value
              }
            }
            if (
              [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48].includes(index)
            ) {
              let value = cell.value;

              // Ensure the value is a string before using replace
              if (typeof value === "string") {
                cell.value = parseFloat(value) / 100;
              }
            }
          });

          cell.value = value;
          cell.font = { bold: true };
        });

        // Apply borders to TOTAL row
        totalRow.eachCell((cell, colIndex) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (colIndex === 49) {
            cell.alignment = { horizontal: "right" };
          }
        });
      }

      [
        3, 4, 7, 8, 11, 12, 15, 16, 19, 20, 23, 24, 27, 28, 31, 32, 35, 36, 39,
        40, 43, 44, 47, 48,
      ].forEach((col) => (worksheet.getColumn(col).numFmt = `"₱"#,##0.00`));

      [5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49].forEach((col) => {
        const column = worksheet.getColumn(col);
        column.eachCell((cell) => {
          cell.numFmt = "0.00%"; // Apply percentage format to each cell in the column
        });
      });

      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellValue = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, cellValue.length);
        });
        column.width =
          column.number >= 2 && column.number <= 49 ? 20 : maxLength + 6;
      });

      // Download the Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "table-data.xlsx";
      link.click();
    };

    return {
      convertDateReportFormat,
      convertDateFormat,
      convertAmountFormat,
      paginationItem,
      handlePageChange,
      filterLimit,
      modifiedDataHandler,
      JAN_activemem,
      JAN_remittance,
      JAN_availment,
      JAN_percent,
      FEB_activemem,
      FEB_remittance,
      FEB_availment,
      FEB_percent,
      MAR_activemem,
      MAR_remittance,
      MAR_availment,
      MAR_percent,
      APR_activemem,
      APR_remittance,
      APR_availment,
      APR_percent,
      MAY_activemem,
      MAY_remittance,
      MAY_availment,
      MAY_percent,
      JUN_activemem,
      JUN_remittance,
      JUN_availment,
      JUN_percent,
      JUL_activemem,
      JUL_remittance,
      JUL_availment,
      JUL_percent,
      AUG_activemem,
      AUG_remittance,
      AUG_availment,
      AUG_percent,
      SEP_activemem,
      SEP_remittance,
      SEP_availment,
      SEP_percent,
      OCT_activemem,
      OCT_remittance,
      OCT_availment,
      OCT_percent,
      NOV_activemem,
      NOV_remittance,
      NOV_availment,
      NOV_percent,
      DEC_activemem,
      DEC_remittance,
      DEC_availment,
      DEC_percent,
      exportTableToExcel,
    };
  },
};
</script>
<style scoped>
.header-title {
  margin-top: 18px;
}
.header-title h3 {
  color: #f37420;
}
.header-title h4 {
  color: #4e4e4e;
  font-weight: 700;
}
.main-table {
  max-width: 1550px;
  overflow: auto;
}
.col-span-1 {
  min-width: 140px;
}
.col-span-2 {
  min-width: 180px;
}
.col-span-3 {
  min-width: 200px;
}
.col-span-4 {
  min-width: 250px;
}
.col-span-5 {
  min-width: 300px;
}
.col-span-max {
  min-width: 540px;
}
td {
  text-align: left;
}

.amount-alignment {
  text-align: right;
}
</style>
